import _ from 'lodash'

export default {
    state: {
        categories: [],
    },
    mutations: {},
    actions: {
        bindCategories({ dispatch }) {
            return dispatch('bindCollection', 'categories')
        },

        async createCategory({ dispatch }, data) {
            return await dispatch('createDocument', { collection: 'categories', data: data })
        },

        async getCategory({ dispatch }, id) {
            return await dispatch('getDocument', { collection: 'categories', id: id })
        },

        async updateCategory({ state, dispatch }, data) {
            _.forEach(state.stores, async store => {
                const index = _.findIndex(store.categories, { id: data.id })
                if (index > -1) {
                    store.categories[index] = data
                    await dispatch('updateStore', store)
                }
            })
            return await dispatch('updateDocument', { collection: 'categories', data: data })
        },

        async deleteCategory({ state, dispatch }, data) {
            _.forEach(state.stores, async store => {
                const index = _.findIndex(store.categories, { id: data.id })
                if (index > -1) {
                    store.categories.splice(index, 1)
                    await dispatch('updateStore', store)
                }
            })
            return await dispatch('deleteDocument', { collection: 'categories', id: data })
        }
    },
}
